/* ––
 * ––– Imports
 * –––––––––––––––––––––––––––––––– */
import AppTheme from 'components/App/Theme';
import CssBaseline from '@mui/material/CssBaseline';
import UnavailableCampaignPageIndex from 'pages/UnavailableCampaignPage';
import React from 'react';
import ReactDOM from 'react-dom';

/* ––
 * ––– Bootstrap funtion
 * –––––––––––––––––––––––––––––––– */
window.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('unavailable-campaign-page-wrapper');
  if (!container) return false;

  ReactDOM.render(
    <AppTheme>
      <CssBaseline />
      <UnavailableCampaignPageIndex />
    </AppTheme>,
    container,
  );

  return true;
});
